import { createFileRoute } from "@tanstack/react-router";
import { SettingsContainer } from "@/features/settings/layouts";
import {
	parseSettingsTab,
	type SettingsTabId,
} from "@/features/settings/lib/settings-tabs";

export const Route = createFileRoute("/$store/_layout/settings")({
	validateSearch: (
		search: Record<string, unknown>,
	): { aba: SettingsTabId } => ({
		aba: parseSettingsTab(search.aba),
	}),
	component: SettingsPage,
});

function SettingsPage() {
	const { aba } = Route.useSearch();
	return <SettingsContainer tab={aba} />;
}
